import { generatePath } from 'react-router';

export const routes = {
  auth: 'auth',
  selectIntermediary: 'select-intermediary',
  proposals: 'proposals',
  proposalsRoutes: {
    new: 'new',
    edit: 'edit/:id',
    editRoutes: {
      clientDetails: 'client-details',
      productSelection: 'product-selection',
      investmentDetails: 'investment-details',
      proposalSummary: 'summary',
      application: 'application',
      applicationRoutes: {
        personalDetails: 'personal-details',
        taxDetails: 'tax-details',
        thirdParties: 'third-parties',
        paymentMethods: 'payment-methods',
        appointIntermediary: 'appoint-intermediary',
        justPortfolio: 'just-portfolio'
      },
      signing: 'signing',
      signingSummary: 'signing-summary'
    }
  },
  reports: 'reports',
  reportsRoutes: {
    new: 'new',
    newReportRoutes: {
      selectClients: 'select-clients',
      reportPeriod: 'report-period',
      review: 'review'
    }
  },
  comingSoon: 'coming-soon',
  legal: 'legal',
  support: 'support',
  otherApps: 'other-apps',
  dashboard: 'dashboard',
  clients: 'clients',
  clientRoutes: {
    clientDashboard: ':clientId',
    clientChildRoutes: {
      clientProfile: 'client-profile'
    }
  },
  caseTracking: 'case-tracking',
  caseTrackingRoutes: {
    instruction: 'instruction/:instructionId'
  },
  myPractice: 'my-practice'
} as const;

export const generateEditProposalPath = (id: number) =>
  generatePath(`/${routes.proposals}/${routes.proposalsRoutes.edit}`, {
    id: `${id}`
  });

export const generateWildcardEditProposalPath = (id: number) => {
  return generatePath(`/${routes.proposals}/${routes.proposalsRoutes.edit}/*`, {
    '*': '*',
    id: `${id}`
  });
};

export const generateInvestmentDetailsPath = (id: number) => {
  return generatePath(
    `/${routes.proposals}/${routes.proposalsRoutes.edit}/${routes.proposalsRoutes.editRoutes.investmentDetails}/`,
    { id: `${id}` }
  );
};

export const generateApplicationPath = (id: number) => {
  return generatePath(
    `/${routes.proposals}/${routes.proposalsRoutes.edit}/${routes.proposalsRoutes.editRoutes.application}/`,
    { id: `${id}` }
  );
};

export const generateProposalSummaryPath = (id: number) => {
  return generatePath(
    `/${routes.proposals}/${routes.proposalsRoutes.edit}/${routes.proposalsRoutes.editRoutes.proposalSummary}/`,
    { id: `${id}` }
  );
};

export const generateSigningPath = (id: number) => {
  return generatePath(
    `/${routes.proposals}/${routes.proposalsRoutes.edit}/${routes.proposalsRoutes.editRoutes.signing}/`,
    { id: `${id}` }
  );
};

export const generateNewProposalPath = () =>
  generatePath(`/${routes.proposals}/${routes.proposalsRoutes.new}`);

export const generateProposalOverviewPath = () => generatePath(`/${routes.proposals}`);

export const isOnHomePage = (pathName: string) => pathName.endsWith(routes.proposals);
